import { render, staticRenderFns } from "./BannerMediaCreateForm.vue?vue&type=template&id=86a5b3f0&"
import script from "./BannerMediaCreateForm.vue?vue&type=script&lang=js&"
export * from "./BannerMediaCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports